import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { ShortObject } from '../../project-misc/data/project/short-json-object';
import { User } from 'projects/core/src/lib/login/data/user';
import {
  CabinetComplexityVariation
} from 'projects/app-misc/src/app/modules/reports/data/cabinet-complexity-variation';
import { ProjectStatus } from 'projects/app-misc/src/app/modules/project-misc/data/project/statuses/project-status';

@JsonObject('model.CabinetRoom')
export class CabinetRoom extends AbstractModel {

  @JsonProperty(Number, 'id')
  id?: number;

  @JsonProperty(String, 'roomName')
  roomName?: string;

}
